document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-twt-blog-sort]');
  if (!select) return;

  const grid = select.closest('.twt-blog').querySelector('[data-twt-blog-grid]');
  const cards = [...grid.querySelectorAll('[data-published]')];
  const direction = select.value === 'oldest' ? 1 : -1;

  cards
    .sort((a, b) => (Number(a.dataset.published) - Number(b.dataset.published)) * direction)
    .forEach((card) => grid.appendChild(card));
});
